import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastInfo } from './toasts-info';
import { ToastService } from 'src/services/toast.service';

@Component({
  selector: 'app-toasts',
  templateUrl: './toasts.component.html',
  styleUrls: ['./toasts.component.scss']
})
export class ToastsComponent implements OnInit {

  // constructor() { }

  // @Input() options: ToastInfo;

  // @Output() close = new EventEmitter<void>();

  // ngOnInit(): void {
  // }

  // closeToast(): void {
  //   this.close.emit();
  // }

  activeToasts: ToastInfo[] = [];
  isIE = false;
  constructor(private toastService: ToastService) { }

  ngOnInit() {
    this.toastService.getToasts().subscribe((data: ToastInfo[]) => {
      this.activeToasts = data;
    });
    const ua = window.navigator.userAgent;
    const trident = ua.indexOf('Trident/');
    if (trident > 0) {
      const rv = ua.indexOf('rv:');
      if (rv > 0) {
        this.isIE = true;
      } else {
        this.isIE = false;
      }
    }
  }

  onToastClick(id: string) {
    this.toastService.removeToast(id);
  }

}
